import axios from '@axios';

const base = '/api/v1/purple-post/print-queue';

export default {
  getPrintQueue() {
    return axios.get(`${base}/`);
  },
};
